import { langRoutePath } from '@bcf-v2/routes/common/app/paths/lang-route-path';
import { liveCasinoRouteI18n } from '../i18n/live-casino-route-i18n';

export function liveCasinoRoutePath(): string {
  return `${langRoutePath()}/${liveCasinoRouteI18n()}`;
}
